export { default as Icon } from './icon';
export { default as Form } from './form';
export { default as Mention } from './mention';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_compatible@1.0.2@@ant-design/compatible/es/index.js
// module id = 77
// module chunks = 0